import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-t border-ink-700 bg-ink-950 px-4 py-12 sm:px-6 sm:py-16" data-id="element-82" data-mp="1gcxoeescsrx5">
      <div className="mx-auto w-full max-w-2xl" data-id="element-83" data-mp="2e0g1g1t1sg6y">
        <SectionHeading eyebrow="Klare Antworten" title="Häufig gestellte Fragen" data-id="element-84" data-mp="2dzxti7x0wdj7" />

        <div className="mt-8 space-y-2.5" data-id="element-85" data-mp="292eh7djvyatw">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ink-700 bg-ink-800" data-id="element-86" data-mp="1z3748rh2ci7b" data-mpi={index}>
                <h3 data-id="element-87" data-mp="snwcghkbayn4">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left" data-id="element-88" data-mp="soekebgc71av">
                    <span className="text-[15px] font-semibold leading-snug text-white" data-id="element-89" data-mp="ug9artn22abl">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-90" data-mp="kibo3akugll3" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-ink-700 px-4 py-3.5 text-[15px] leading-relaxed text-white/70" data-id="element-91" data-mp="3swk0b8326zr3">
                    {faq.a}
                  </p>}
              </div>;
        })}
        </div>

        <CtaBlock label="Alle Fragen geklärt — los geht's" showTimer={false} note="Einmalige Zahlung von 19 € · 7 Tage Garantie" className="mt-8" data-id="element-92" data-mp="3o03bscry6jdh" />
      </div>
    </section>;
}